import SubscriptionProductPriceModal from './SubscriptionProductPriceModal';

export default {
  SubscriptionProductPriceModal,
};
